<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.materialCode')">
              <j-input :placeholder="$t('label.pleaseEnterTheMaterialCode')" v-model="queryParam.code"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="助记码">
              <j-input placeholder="请输入助记码" v-model="queryParam.quidkCode"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('label.materialName')">
                <j-input :placeholder="$t('label.pleaseEnterTheNameOfTheMaterial')" v-model="queryParam.name"></j-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button v-show=true @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <a-button v-show=false type="primary" icon="download" @click="handleExportXls('物料通用名档案')">{{$t('button.export')}}</a-button>
      <a-upload v-show=false name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>
      <a-button v-show=false :disabled="isSyncUpdateDataDisabled" @click="syncUpdateData" type="primary" icon="sync">同步更新</a-button>
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
      <a-dropdown v-show="false">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item v-show="false">
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-material-modal ref="modalForm" @ok="modalFormOk"></efs-md-material-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdMaterialModal from './modules/EfsMdMaterialModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { getAction, getActionLongWait, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'EfsMdMaterialList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsMdMaterialModal,
      JInput
    },
    data () {
      return {
        description: '物料通用名档案管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'tableHeader.materialCode',
            scopedSlots: { title: 'tableHeader.materialCode'},
            align:"center",
            dataIndex: 'code'
          },
          {
            title:'助记码',
            align:"center",
            dataIndex: 'quidkCode'
          },
          {
            slotName: 'tableHeader.materialName',
            scopedSlots: { title: 'tableHeader.materialName'},
            align:"center",
            dataIndex: 'name'
          },
          {
             slotName: 'tableHeader.materialCommonName',
            scopedSlots: { title: 'tableHeader.materialCommonName'},
            align:"center",
            dataIndex: 'buffer1'
          },
          {
             slotName: 'tableHeader.specification',
            scopedSlots: { title: 'tableHeader.specification'},
            align:"center",
            dataIndex: 'spec'
          },
          {
             slotName: 'tableHeader.model',
            scopedSlots: { title: 'tableHeader.model'},
            align:"center",
            dataIndex: 'model'
          },
          {
            title:'物料通用名分类',
            align:"center",
            dataIndex: 'mmGrpCode_dictText'
          },
          {
             slotName: 'tableHeader.unitOfMeasurement',
            scopedSlots: { title: 'tableHeader.unitOfMeasurement'},
            align:"center",
            dataIndex: 'mainUnit_dictText'
          },
          {
            slotName: 'tableHeader.validOrNot',
            scopedSlots: { title: 'tableHeader.validOrNot'},
            align:"center",
            dataIndex: 'validFlag_dictText'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/material/efsMdMaterial/list",
          delete: "/material/efsMdMaterial/delete",
          deleteBatch: "/material/efsMdMaterial/deleteBatch",
          exportXlsUrl: "/material/efsMdMaterial/exportXls",
          importExcelUrl: "material/efsMdMaterial/importExcel",

        },
        dictOptions:{},
        isSyncUpdateDataDisabled: false
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      syncUpdateData(){
        this.isSyncUpdateDataDisabled = true;
        this.loading=true;
        getActionLongWait("/material/efsMdMaterial/syncUpdate",'').then((res)=>{
          if (res.success) {
            this.loadData();
            this.isSyncUpdateDataDisabled = false;
          } else {
            this.$message.warning(res.message);
            this.isSyncUpdateDataDisabled = false;
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>